import React from 'react';

import {hashedClasses} from '@pb/kit-util-with-css-module';

import {ComboboxItem} from './combo-box-item.component';
import comboBoxStyles from './combo-box.component.module.styl';

import type {ComboboxItemProps} from './combo-box-item.component';

const classes = hashedClasses(comboBoxStyles);

type OmittedProps = Omit<ComboboxItemProps<unknown>, 'value' | 'mix' | 'caption'>;

interface Props extends OmittedProps {
    value?: unknown,
    caption?: string,
}

function DefaultItem(props: Props) {
    const {
        value = 'default',
        caption = '',
    } = props;

    return (
        <ComboboxItem
            {...props}
            caption={caption}
            value={value}
            className={classes['combo-box__item_default']}
        />
    );
}

DefaultItem.displayName = 'DefaultItem';

export {DefaultItem};
